module.exports = __webpack_public_path__ + "static/media/update-bar.125d117c.svg";